<template>
  <div id="login">
    <el-container style="height: 100%;">
      <el-header style="background-color: #409EFF">
        <el-row style="line-height: 60px; color:#FFF">
          <el-col :span="16"><span class="el-icon-menu"></span> 小度订单助手</el-col>
          <el-col :span="1"><el-link style="color:#FFF;font-size: 12pt; text-decoration:none;"  target="_blank" href="https://fuwu.taobao.com/ser/detail.htm?service_code=ts-24407">订购</el-link></el-col>
          <el-col :span="6" >
            <div v-if="logined" ><span class="el-icon-user-solid"></span>【meyau】
              <el-link style="color:#FFF;font-size: 12pt;text-decoration:none;"  @click="logout">注销</el-link>&#8194;&#8194;剩余365天
            </div>
            <div v-else="logined" class="login">
              <el-link style="color:#FFF;font-size: 12pt; text-decoration:none;" href="http://container.open.taobao.com/container?appkey=12583049">请登录</el-link></div>

          </el-col>
          <el-col :span="1">
            <div>
              <a href="http://www.taobao.com/webww/ww.php?ver=3&touid=wgaofa&siteid=cntaobao&status=1&charset=utf-8"
                 target="_blank"><img alt="点这里给我发消息" border="0" src="http://amos.alicdn.com/online.aw?v=2&uid=wgaofa&site=cntaobao&s=1&charset=utf-8"></a>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-container >
        <el-aside width="200px"  style="height: 1200px;">
          <el-menu
            @select="handleSelect"
            @open="handleOpen"
            :default-active="active"
            class="el-menu-vertical-demo1"
            style="font-size: 20px;height: 100%;"
          >
            <el-menu-item index="1">
              <i class="el-icon-s-home"></i>
              <span slot="title">首 页</span>
            </el-menu-item>
            <!--<el-menu-item index="2">
              <i class="el-icon-tickets"></i>
              <span slot="title">同步订单</span>
            </el-menu-item>
            <el-menu-item index="3">
              <i class="el-icon-tickets"></i>
              <span slot="title">显示数据</span>
            </el-menu-item>
            <el-menu-item index="4">
              <i class="el-icon-tickets"></i>
              <span slot="title">批量发货</span>
            </el-menu-item>
            <el-menu-item index="5">
              <i class="el-icon-tickets"></i>
              <span slot="title">批量备注</span>
            </el-menu-item>
            <el-menu-item index="6">
              <i class="el-icon-tickets"></i>
              <span slot="title">延长收货</span>
            </el-menu-item>
            <el-menu-item index="7">
              <i class="el-icon-tickets"></i>
              <span slot="title">配货统计</span>
            </el-menu-item>
            <el-menu-item index="8">
              <i class="el-icon-tickets"></i>
              <span slot="title">商品管理</span>
            </el-menu-item>
            <el-menu-item index="9">
              <i class="el-icon-tickets"></i>
              <span slot="title">定制功能</span>
            </el-menu-item>
            <el-menu-item index="10">
              <i class="el-icon-tickets"></i>
              <span slot="title">权限管理</span>
            </el-menu-item>-->

            <el-submenu index="G1">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>订单管理</span>
              </template>
              <el-menu-item index="2">
                <i class="el-icon-tickets"></i>
                <span slot="title">同步订单</span>
              </el-menu-item>
              <el-menu-item index="3">
                <i class="el-icon-tickets"></i>
                <span slot="title">显示数据</span>
              </el-menu-item>
              <el-menu-item index="7">
                <i class="el-icon-tickets"></i>
                <span slot="title">配货统计</span>
              </el-menu-item>
              <el-menu-item index="9">
                <i class="el-icon-tickets"></i>
                <span slot="title">定制功能</span>
              </el-menu-item>
              <el-menu-item index="13">
                <i class="el-icon-tickets"></i>
                <span slot="title">导入数据</span>
              </el-menu-item>
              <el-menu-item index="14">
                <i class="el-icon-tickets"></i>
                <span slot="title">买家修改SKU</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="G2">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>批量操作</span>
              </template>
              <el-menu-item index="4">
                <i class="el-icon-tickets"></i>
                <span slot="title">批量发货</span>
              </el-menu-item>
              <el-menu-item index="5">
                <i class="el-icon-tickets"></i>
                <span slot="title">批量备注</span>
              </el-menu-item>
              <el-menu-item index="6">
                <i class="el-icon-tickets"></i>
                <span slot="title">延长收货</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="G3">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>商品管理</span>
              </template>
              <el-menu-item index="8">
                <i class="el-icon-tickets"></i>
                <span slot="title">商品管理</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="G4">
              <template slot="title">
                <i class="el-icon-location"></i>
                <span>店铺设置</span>
              </template>
              <el-menu-item index="10">
                <i class="el-icon-tickets"></i>
                <span slot="title">店铺绑定</span>
              </el-menu-item>
              <el-menu-item index="11">
                <i class="el-icon-tickets"></i>
                <span slot="title">权限管理</span>
              </el-menu-item>
            </el-submenu>



            <el-menu-item index="12">
              <i class="el-icon-tickets"></i>
              <span slot="title">使用帮助</span>
            </el-menu-item>


          </el-menu>
        </el-aside>
        <el-main>

          <h2 style="color: #dd6161">升级了，升级了，订单助手升级了！！！</h2>
          <h3>软件说明</h3>
          <h4>一、关于升级</h4>
          <p style="font-weight: bold;color: #3a8ee6">1、软件升级是操作界面升级，不是您订购的功能版本，您订购的功能是基础版还是高级版，在右上角会有显示您的功能版本。</p>
          <p style="font-weight: bold;color: #3a8ee6">2、新版本的操作流程和老版本基本一样，如果有不明白，可联系在线客服为您解答。</p>
          <h4>二、简要说明</h4>
          <p>1、之前订购的基础版，如果需要升级到高级版，直接订购高级版，付款时只需支付差价。</p>
          <p>2、试用版用户只可查看最近7天的数据。</p>
          <p>3、高级版支持子号登录，登录前主号先给子号授权。</p>
          <p>4、高级版可同步商品信息，设置商品简称，成本。</p>
          <p>5、高级版可批量导入快递单，批量发货。</p>
          <p>6、高级版可生成配货单， 查看某款的销量，软件按颜色尺码属性进行统计汇总</p>
          <p>7、子号没有相关功能操作权限，主号需要通过权限管理模块授权子号软件可用的功能。</p>

          <router-view v-wechat-title='$route.meta.title'></router-view>

          <div align="left" style="margin-top: 200px;margin-left: 20px">
              <span style="font-size: 12px">Copyright ©2020 ZDINFO.TOP 版权所有
                <el-link href="https://beian.miit.gov.cn"  type="primary" style="margin-left: 10px;font-size: 12px">豫ICP备17046731号</el-link></span>
          </div>
          <el-button @click="logintest" v-show="false">Login</el-button>

        </el-main>
      </el-container>

    </el-container>


  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"
  import cookies from "../api/cookie"

  //https://g.alicdn.com/sj/securesdk/0.0.3/securesdk_v2.js


  //const Base64 = require('js-base64').Base64 ;
    export default {
      name: "Login",
      data(){
        return{
          appeky:'',
          sessionkey:'',
          topparam:'',
          topsign:'',
          active:"1",
          logined: false,
          userName:'',
          topParam:'',
          tbUser:{
            nick:'meyau12',
            subNick:'',
            appkey: '',
            sessionkey:'',
            expiresIn: 0,
            r1ExpiresIn:0,
            r2ExpiresIn:0,
            r2ExpiresIn:0,
            refreshToken:'',
            visitorId:'',
            w1ExpiresIn:0,
            w2ExpiresIn:0,
            subVisitorId:''
          }
        }
      },
      methods: {

        handleOpen(key, keyPath) {
          console.log(key, keyPath);
        },

        onCopy: function () {
          this.topParam = '点击评价日志\t可查看软件自动\t评价的历史\t记录123\t<img alt="点这里给我发消息" border="0" src="http://amos.alicdn.com/online.aw?v=2&uid=wgaofa&site=cntaobao&s=1&charset=utf-8"';

          this.$copyText(this.topParam)


        },

        test: function(){
          let param={
            filename:'test.xls',
          }
          $api.post("/excel", param, response =>{
            console.log(response);
            //this.$message.error(response.data.message);
          })
        },

        logintest:function(){
          storage.set("nick", "上海飞钰商贸有限公司");
          storage.set("subnick", "");
          storage.set("days","0");
          storage.set("token", "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzZXNzaW9ua2V5IjoiNjEwMjMwNjdhNDk5NDgxODlhOVpaZTEwMDFmZjJkNmQwMjk5MGE4ZjM3MjE1NjYxOTAxMzAyNjY0IiwiZXhwIjoxNzExMDA3NTkyLCJ1c2VybmFtZSI6IuS4iua1t-mjnumSsOWVhui0uOaciemZkOWFrOWPuCIsInN1Ym5pY2siOiLkuIrmtbfpo57pkrDllYbotLjmnInpmZDlhazlj7g657qi6LGGIn0.bn88IZK45vGtvnTtwtpu85-HLOB0S3-8VGWAIFrj5yg");
          this.$router.replace({name: 'Main'});
          },
        login:function(){
          let param = {
            appkey: this.appkey,
            sessionkey:this.sessionkey,
            topparam: this.topparam,
            topsign: this.topsign,
            ati: cookies.getCookie("_ati"),
          }
          $api.post("/top", param, response =>{
            let dataResult = response.data;
            if (dataResult.state == 1 && dataResult.message == "ok") {
              storage.set("nick", dataResult.data.nick);
              storage.set("subnick", dataResult.data.subnick);
              storage.set("deadline", dataResult.data.deadline)
              storage.set("days",dataResult.data.days);
              storage.set("token", dataResult.data.token);
              //新登录 清除上次保存的时间
              storage.remove("created");
              console.log(dataResult.data.days);
              this.$router.replace({name: 'Main'});

            }else{
              this.$message({
                type: 'error',
                message: '抱歉，登录失败'+dataResult.message
              })
            }
          });
        },

        handleSelect: function (index) {
          if(index == '12'){
            this.$router.push({name: 'Help2'});
          }else {
            this.$message({
              type: 'error',
              message: '您当前没有登录，请登录后进行操作！'
            });
          }

        },
        getUrl:function (name) {
          return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null

        }
      },mounted() {
        this.appkey = this.getUrl("top_appkey");
        this.sessionkey = this.getUrl("top_session"); //top_parameters  top_session top_sign
        this.topparam = this.getUrl("top_parameters");
        this.topsign =  this.getUrl("top_sign");
        console.log(this.appkey);
        if(this.appkey != null){
          this.login();
        }else {
          let nick = storage.get("nick");
          if (nick != null) {
            this.$router.replace({name: "Index"});
          }
        }

      },
      created(){


      }

    }
</script>

<style >
  #login {
    font-family: ‘宋体’,'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    height: 100%;
  }

  .el-link.el-link--default {
    color: #FFF;
  }

</style>


<!--getTopInfo:function () {
console.log(this.tbUser.nick);
let Base64 = require('js-base64').Base64
let appkey = this.$route.query.top_appkey;
let session = this.$route.query.top_session;
let topparam = this.$route.query.top_parameters;
if((appkey != null) && (session !=null) &&(topparam != null)){
console.log(session);
this.tbUser.appkey = appkey;
this.tbUser.sessionkey = session;
if(topparam != null) {
this.topParam = Base64.decode(topparam);
}else{
console.log("topparam is null");
}

let paramlist = ''.split('&');
for(let i=0;i<paramlist.length;i++){
let param = paramlist[i].split('=');
let key=param[0];
if(key == "visitor_nick"){
this.username =
storage.set("nick", param[1]);
storage.set("sessionkey",session);
this.tbUser.nick = param[1];
}
else if(key == "expires_in"){
this.tbUser.expiresIn = param[1];
}
else if(key == "iframe"){
//this.tbUser.nick = param[1];
}
else if(key == "r1_expires_in"){
this.tbUser.r1ExpiresIn = param[1];
}
else if(key == "r2_expires_in"){
this.tbUser.r2ExpiresIn = param[1];
}
else if(key == "re_expires_in"){
this.tbUser.reExpiresIn = param[1];
}
else if(key == "refresh_token"){
this.tbUser.refreshToken = param[1];
}
else if(key == "ts"){
this.tbUser.ts = param[1];
}
else if(key == "visitor_id"){
this.tbUser.visitorId = param[1];
}
else if(key == "w1_expires_in"){
this.tbUser.w1ExpiresIn = param[1];
}
else if(key == "w2_expires_in"){
this.tbUser.w2ExpiresIn = param[1];
}
else if(key == "sub_taobao_user_nick"){
this.tbUser.subNick = param[1];
}
else if(key == "sub_visitor_id"){
this.tbUser.subVisitorId = param[1];
}
}
this.$router.replace({path: '/'});
console.log(this.topParam)
}
},-->



// WEBPACK FOOTER //
// src/page/Login.vue